import { render, staticRenderFns } from "./SelectPhoto.vue?vue&type=template&id=633b9bd6&scoped=true&"
import script from "./SelectPhoto.vue?vue&type=script&lang=ts&"
export * from "./SelectPhoto.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPhoto.vue?vue&type=style&index=0&id=633b9bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b9bd6",
  null
  
)

export default component.exports